import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';
import { SuiModalService, ModalSize } from '@richardlt/ng2-semantic-ui';
import { AuditTrailDetailModal } from 'src/modules/features/admin/modals';
import { Subject } from 'rxjs';
import { map, take, takeUntil, tap } from 'rxjs/operators';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';

import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  CompanyService,
  DashboardProvider,
} from 'src/modules/features/contractor/services';
import { ViewHistoryModal } from 'src/modules/features/contractor/modals/view-history-modal/view-history-modal.component';

@Component({
  selector: 'app-company-history-structure',
  templateUrl: './history-structure.component.html',
  styleUrls: ['./history-structure.component.scss'],
})
export class HistoryStructureComponent implements OnInit {
  companyDirectors = [];
  success: any;
  error: any;
  unsubscribe$: Subject<boolean> = new Subject();
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number;
  rows: number;
  maxSize: number = 7;
  organizationId: string;
  companyType: Array<any> = [];
  baseUrl = environment.API_SERVER;
  ownershipType: Array<any> = [];
  countries: Array<any> = [];
  isEdit: boolean = false;
  isPending: boolean = false;
  chatLink;
  companyShareholderForm: FormGroup;
  currentForm: FormGroup;
  changeRequestId;
  result = [];
  documents = [];
  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'firstName',
        op: 'cn',
        data: '',
      },
      {
        field: 'lastName',
        op: 'cn',
        data: '',
      },
    ],
  };
  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'individual_ownership_type',
      },
    ],
  };
  directorStatus: string;
  message;
  redirect_url;
  applicationType;
  affiliateTypeName!: string;
  affiliateTypeId!: string;
  companyTypeId = JSON.parse(window.localStorage.getItem('user')).organizationId
    .jpaContractor.companyType.optionId;
  @Input() allStatus: any;
  @Input() typeStructure!: string;
  subject = new Subject<boolean>();
  @Input() personnelStructureKeys!: string[];
  structureObject: any;
  pendingArr: boolean[] = [];
  companyAffiliateTypes;
  allAffiliateTypes;
  allStructures = [];
  redirect_params: any;
  pendingHistory;
  history;
  currentPage;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private companyOwnershipService: CompanyOwnershipService,
    private fb: FormBuilder,
    private companySvc: CompanyService,
    private dashboardSvc: DashboardProvider
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    this.activatedRoute.queryParams.subscribe((params) => {
      this.affiliateTypeId = params.typeId;
      this.affiliateTypeName = params.typeName;
      // this.filter.filters = JSON.stringify(this.searchFilter);
      this.getVerificationStatus();
    });
  }
  getVerificationStatus() {
    this.pending = true;
    this.dashboardSvc
      .getStatus({
        organizationId: this.organizationId,
      })
      .subscribe((res) => {
        this.allStatus = res;
        this.personnelStructureKeys = Object.keys(res).filter((key) =>
          key.includes('STRUCTURE')
        );
        let statusKeys = Object.keys(this.allStatus);
        this.typeStructure = statusKeys.find((statusKey) =>
          statusKey.toLowerCase().includes(this.affiliateTypeName.toLowerCase())
        );
        this.getPage(1);
      });
  }
  ngOnInit() {}
  getPage(page) {
    this.pending = true;
    this.companySvc
      .getRequestHistory({
        organizationId: this.organizationId,
        changeRequestType: this.typeStructure,
        params: this.filter,
      })
      .pipe(
        tap((res) => {
          this.totalItems = +res['records'];
          this.currentPage = page;
          this.rows = this.filter.rows;
        })
      )
      .subscribe(
        (res: any) => {
          this.pendingHistory = res['rows'];
          this.pending = false;
        },
        (error) => {
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
          this.pending = false;
        }
      );
  }
  nextPage(value) {
    this.filter.page = value;
    this.getPage(this.filter.page);
  }
  getColorForLabel(label: string): string {
    switch (label) {
      case 'PENDING':
        return '#FFAC33';
      case 'DISCARDED':
        return '#E4E5E7';
      case 'VERIFIED':
        return '#5FD3A4';
      case 'UNVERIFIED':
        return '#FB4037';
      default:
        return '#E4E5E7';
    }
  }
  getColorTextForLabel(label: string): string {
    switch (label) {
      case 'DISCARDED':
        return '#505050';
      default:
        return '#FFFFFF';
    }
  }
  viewHistory(item) {
    this.modalService.open(
      new ViewHistoryModal(
        'View History',
        this.typeStructure,
        {
          isPending: false,
        },
        this.organizationId,
        item.changeRequestId
      )
    );
  }

  searchRecords(event) {}
  displayRecords(event) {}
  sortRecords(event) {}
}
